import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../landing/assets/logo.svg";

type NavItem = {
  label: string;
  to: string;
  external?: boolean;
};

const NAV_ITEMS: NavItem[] = [
  // { label: "Agency", to: "https://www.app-installs.net/", external: true },
  // { label: "Partnership", to: "/partnership" },
  // { label: "Referral", to: "/referral" },
  // { label: "Changelog", to: "/changelog" },
];

const desktopLinkClass =
  "text-gray-500 hover:text-gray-900 font-medium text-sm no-underline hover:no-underline will-change-auto";
const desktopActiveClass =
  "text-[#4858A8] font-medium text-sm no-underline will-change-auto";

const mobileLinkClass =
  "block text-gray-600 hover:text-gray-900 font-medium no-underline hover:no-underline will-change-auto";
const mobileActiveClass =
  "block text-[#4858A8] font-medium no-underline will-change-auto";

export const MarketingHeader: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const renderNavLink = (item: NavItem, isMobile: boolean) => {
    const baseClass = isMobile ? mobileLinkClass : desktopLinkClass;
    const activeClass = isMobile ? mobileActiveClass : desktopActiveClass;

    if (item.external) {
      return (
        <a
          key={item.label}
          href={item.to}
          className={baseClass}
          onClick={isMobile ? () => setIsMenuOpen(false) : undefined}
        >
          {item.label}
        </a>
      );
    }

    return (
      <NavLink
        key={item.label}
        to={item.to}
        className={({ isActive }) => (isActive ? activeClass : baseClass)}
        onClick={isMobile ? () => setIsMenuOpen(false) : undefined}
      >
        {item.label}
      </NavLink>
    );
  };

  return (
    <header className="fixed w-full top-0 bg-white/80 backdrop-blur-md z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center lg:pr-[100px]">
              <Link to="/" className="no-underline hover:no-underline">
                <img
                  src={Logo}
                  alt="App-Installs"
                  className="h-8 w-10 object-contain"
                />
              </Link>
            </div>
            <nav className="hidden lg:block h-5">
              <ul className="flex space-x-10 list-none p-0 m-0 h-full items-center">
                {NAV_ITEMS.map((item) => (
                  <li key={item.label} className="h-full flex items-center">
                    {renderNavLink(item, false)}
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/login"
              className="bg-gray-900 text-white px-6 py-2.5 rounded-xl font-medium text-sm hover:bg-black transition-colors shadow-lg shadow-gray-200 no-underline hover:no-underline"
            >
              Log in
            </Link>
          </div>

          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900 focus:outline-none border-0 bg-transparent"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden pb-4 flex flex-col gap-4">
            <nav className="flex flex-col gap-3">
              {NAV_ITEMS.map((item) => renderNavLink(item, true))}
            </nav>
            <Link
              to="/login"
              className="mt-2 inline-block bg-gray-900 text-white px-6 py-2.5 rounded-xl font-medium text-sm hover:bg-black transition-colors text-center no-underline hover:no-underline"
              onClick={() => setIsMenuOpen(false)}
            >
              Log in
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};
